import { render, staticRenderFns } from "./AddPurposePopup.vue?vue&type=template&id=48414dd2&"
import script from "./AddPurposePopup.vue?vue&type=script&lang=js&"
export * from "./AddPurposePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports